import React from 'react';

const CodeIcon = () => (
  <svg
    className="w-10 h-10 text-green-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 18l6-6-6-6M8 6l-6 6 6 6"
    ></path>
  </svg>
);

export default CodeIcon;


// WEBPACK FOOTER //
// ./src/components/projects/CodeIcon.js